/**
 * CommissionSplitsApiService — batch commission split operations.
 */

import { ApiClient } from '../ApiClient.js';

export class CommissionSplitsApiService {
    /**
     * @param {string[]} dealIds
     * @returns {Promise<Record<string, object[]>>} map of deal_id -> splits[]
     */
    static async getBatch(dealIds = []) {
        const ids = [...new Set((dealIds || []).filter(Boolean))];
        if (!ids.length) return {};
        return ApiClient.get('/api/v1/commission-splits', {
            deal_ids: ids,
        });
    }
}
